import React from 'react';
import { useIntl } from 'react-intl';

import { Grid } from '@xsolla/ui-core';

import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { AgeRestrictionIcon, LegalIcon, ToggleBox } from '../../ui';
import NavigationSettingsLink from '../NavigationSettingsLink';

const LegalSettings = (): JSX.Element => {
  const { ageRestrictionsPath, termsAndPoliciesLegalSettingsPath } = usePaths();
  const intl = useIntl();
  const { currentProject } = useCurrentProject();

  return (
    <>
      <ToggleBox
        title={intl.messages['navigation.settings.legal.label']}
        openByDefault
        dataTestId="navigation-block-legal">
        <Grid cols={2} gap={24}>
          <NavigationSettingsLink
            dataTestId="link-navigation-terms-policies"
            icon={<LegalIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.legal.terms-and-policies.title'],
              path: termsAndPoliciesLegalSettingsPath(currentProject?.id || '')
            }}
            subtitle={intl.messages['navigation.settings.legal.terms-and-policies.subtitle']}
          />
          <NavigationSettingsLink
            dataTestId="link-navigation-age-restrictions"
            icon={<AgeRestrictionIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.legal.age-restrictions.title'],
              path: ageRestrictionsPath(currentProject?.id || '')
            }}
            subtitle={intl.messages['navigation.settings.legal.age-restrictions.subtitle']}
          />
        </Grid>
      </ToggleBox>
    </>
  );
};

export default LegalSettings;
